module.exports = __webpack_public_path__ + "img/performance-blog.c5ea590a.png";